import _ from 'lodash'


export const FETCHING_MYD_USER_COMPETENCES = 'FETCHING_MYD_USER_COMPETENCES'
export const FETCHED_MYD_USER_COMPETENCES = 'FETCHED_MYD_USER_COMPETENCES'


const mydUserCompetencesInit = {
  isFetching: false,
  data: [],
  grouped: {},
}

export function mydUserCompetences(mydUserCompetences=mydUserCompetencesInit, action) {
  switch(action.type) {
    case FETCHING_MYD_USER_COMPETENCES:
      return {
        ...mydUserCompetencesInit,
        isFetching: true,
      }

    case FETCHED_MYD_USER_COMPETENCES:
      return {
        isFetching: false,
        data: action.mydUserCompetences,
        grouped: _.chain(action.mydUserCompetences).groupBy(x => x.mydCompetenceId).sortBy(x => x[0].maxAcquired).reverse().value(),
      }

    default:
      return mydUserCompetences
  }
}
